'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.setMode = setMode;
exports.setAvailableDay = setAvailableDay;
exports.saveAvailability = saveAvailability;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/availability/LOAD';
var LOAD_SUCCESS = 'redux-frontend/availability/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/availability/LOAD_FAIL';

var SET_MODE = 'redux-frontend/availability/SET_MODE';
var SAVE_AVAIL = 'redux-frontend/availability/SAVE_AVAIL';
var SAVE_AVAIL_SUCCESS = 'redux-frontend/availability/SAVE_AVAIL_SUCCESS';
var SAVE_AVAIL_FAIL = 'redux-frontend/availability/SAVE_AVAIL_FAIL';
var SET_AVAIL_DAY = 'redux-frontend/availability/SET_AVAIL_DAY';

var SELECT_AVAIL_DAY = 'redux-frontend/calendar/SELECT_AVAIL_DAY';

var initialState = {
  mode: 'available',
  saved: true,
  availableDays: ['default', 'default', 'default', 'default', 'default', 'default', 'default']
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        availableDays: action.result.user && action.result.user.available_days || initialState.availableDays
      });
    case SELECT_AVAIL_DAY:
      return (0, _extends3.default)({}, state, {
        saved: false
      });
    case SET_MODE:
      return (0, _extends3.default)({}, state, {
        mode: action.mode
      });
    case SAVE_AVAIL:
      return (0, _extends3.default)({}, state);
    case SAVE_AVAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        saved: true
      });
    case SET_AVAIL_DAY:
      return (0, _extends3.default)({}, state, {
        saved: false,
        availableDays: [].concat((0, _toConsumableArray3.default)(state.availableDays.slice(0, action.index)), [action.value], (0, _toConsumableArray3.default)(state.availableDays.slice(action.index + 1)))
      });
    default:
      return state;
  }
}

var analytics = exports.analytics = (0, _defineProperty3.default)({}, SAVE_AVAIL_SUCCESS, function () {
  return { name: 'Saved Availability', category: 'Availability' };
});

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/users/me');
    }
  };
}

function setMode(mode) {
  return {
    type: SET_MODE,
    mode: mode
  };
}

function setAvailableDay() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ask';

  return {
    type: SET_AVAIL_DAY,
    index: index,
    value: value
  };
}

function saveAvailability(months, availableDays) {
  return {
    types: [SAVE_AVAIL, SAVE_AVAIL_SUCCESS, SAVE_AVAIL_FAIL],
    promise: function promise(client) {
      return _promise2.default.all([0, 1].map(function (index) {
        return client.post('/availability', { data: months[index] });
      })).then(function () {
        return client.post('/users/me', { data: { available_days: availableDays } });
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/availability.js
// module id = 477
// module chunks = 47